import { Component } from '@angular/core';

@Component({
  selector: 'irembogov-error-401',
  templateUrl: './error-401.component.html',
})
export class Error401UnauthorizedComponent {}
